import { Flex } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";

export const IDVSection = styled(Flex)`
  flex-direction: column;
`;

export const IDVHeadingWrapper = styled(Flex)`
  justify-content: space-between;
`;

export const IDVHeading = styled.span`
  color: #5b5675;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
`;

export const IDVSectionHeading = styled(IDVHeading)`
  font-weight: 500;
`;

export const Price = styled.span`
  color: #040222;
  font-family: "Euclid Circular B";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-weight: bold;
  cursor: pointer;
  padding: 8px 0;
  margin-top: 8px;
`;

export const DropdownContainer = styled.div<{ expanded: boolean }>`
  overflow: hidden;
  max-height: ${(props) => (props.expanded ? "auto" : "0px")};
  opacity: ${(props) => (props.expanded ? 1 : 0)};
  transition:
    all 150ms cubic-bezier(0.4, 0, 0.2, 1),
    max-height 300ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 300ms cubic-bezier(0.4, 0, 0.2, 1);
`;
